import React from 'react'
import { rem } from 'polished'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'

interface Props {
  title: string
  description: string
}

const actionButtons = [
  { text: 'Customer Service and Sales', href: 'https://au.smrtr.io/9syy' },
  { text: 'Commercial', href: 'https://au.smrtr.io/9syr' },
  { text: 'Engineering', href: 'https://au.smrtr.io/b5Cg' },
  { text: 'Finance', href: 'https://au.smrtr.io/9syZ' },
  { text: 'Marketing', href: 'https://au.smrtr.io/9sz2' },
  { text: 'Product Management and Design', href: 'https://au.smrtr.io/9szc' },
]

function CommunityBanner({
  title,
  description,
}: Props) {
  return (
    <Group direction="vertical">
      <MessageBanner
        kind="informational-secondary"
        align="center"
        heading={title}
        children={description}
      />
      <Group
        direction="horizontal"
        style={{ justifyContent: 'center', marginTop: rem(10) }}
        wrap="wrap"
      >
        {actionButtons.map((button, index) => (
          <TextButton
            key={index}
            href={button.href}
            kind="tertiary"
            size="medium"
          >
            {button.text}
          </TextButton>
        ))}
      </Group>
    </Group>
  )
}

CommunityBanner.displayName = 'CommunityBanner'
export default CommunityBanner
